import { guideSteps } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          index="05"
          label="Stay Updated"
          title="防走丢四步指南"
          desc="换域名、换线路是常有的事，只要记住下面四步，即使旧地址失效也能第一时间找回黑料网站的最新入口。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step, index) => (
            <div
              key={step.id}
              className="relative rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span className="font-heading text-3xl font-bold text-primary-200">{step.step}</span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2.5 text-sm leading-6 text-foreground-600">{step.desc}</p>
              {index < guideSteps.length - 1 && (
                <span className="absolute right-4 top-5 hidden w-5 h-5 items-center justify-center text-background-400 lg:flex">
                  <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start gap-5 rounded-lg border border-accent-200 bg-accent-50 p-6 md:flex-row md:items-center md:justify-between md:p-7">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500 text-accent-950">
              <i className="ri-bookmark-3-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">
                现在就收藏本页，地址随时都在
              </h3>
              <p className="mt-1.5 max-w-2xl text-sm leading-7 text-foreground-700">
                把当前页面加入书签或添加到手机主屏幕，之后无论是入口更换还是镜像调整，回来刷新一次就能看到最新内容。
              </p>
            </div>
          </div>
          <a
            href="#entries"
            className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-6 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-links-line text-base" aria-hidden="true"></i>
            </span>
            回到入口列表
          </a>
        </div>
      </div>
    </section>
  );
}